import styled from 'styled-components';
import { StyledText } from '@leasequery/lq.react-component-library';

const NoDataPanel = styled(StyledText)`
  padding: ${(props): string => props.theme.spaces.lg};
`;

export { NoDataPanel };
